import { render, staticRenderFns } from "./spinning-loader.vue?vue&type=template&id=5a190813&functional=true"
import script from "./spinning-loader.vue?vue&type=script&lang=js"
export * from "./spinning-loader.vue?vue&type=script&lang=js"
import style0 from "./spinning-loader.vue?vue&type=style&index=0&id=5a190813&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports